import { render, staticRenderFns } from "./ProductServiceList.vue?vue&type=template&id=5de265b6&scoped=true"
import script from "./ProductServiceList.vue?vue&type=script&lang=js"
export * from "./ProductServiceList.vue?vue&type=script&lang=js"
import style0 from "./ProductServiceList.vue?vue&type=style&index=0&id=5de265b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de265b6",
  null
  
)

export default component.exports